import styled from "styled-components/macro";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 1rem;
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 4rem 12.6rem 3rem 12.5rem;
  }
`;
export const ConteinerText = styled.div`
  display: ${({ sendMessage, error }) =>
    sendMessage || error ? "none" : "flex"};
  flex-direction: column;
  align-items: center;
  justify-content: start;
  margin-bottom: 1rem;

  opacity: ${({ scroll }) => (scroll > 3500 ? "1" : "0")};
  transition: opacity 0.5s ease-in-out;

  h1 {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 138%;
    color: #000000;
    margin-bottom: 1rem;
  }
  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #676767;
    margin: 0;
  }
  @media (min-width: 992px) {
    opacity: ${({ scroll }) => (scroll > 2800 ? "1" : "0")};
    transition: opacity 2s ease-in-out;
    padding-bottom: 23rem;
    align-items: center;
    justify-content: start;
    h1 {
      font-size: 32px;
      line-height: 44px;
      text-align: start;
    }
    p {
      font-size: 16px;
      line-height: 27px;
      text-align: center;
    }
  }
`;

export const ContainerForm = styled.div`
  display: ${({ sendMessage, error }) =>
    sendMessage || error ? "none" : "flex"};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;
export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  position: relative;

  margin-bottom: ${({ lastInput }) => (lastInput ? "1rem" : "0.8rem")};
  transform: ${({ scroll }) =>
    scroll > 3800 ? "translateX(0)" : "translateX(-500px)"};
  transition: ${({ input2, input3, lastInput }) =>
    input2
      ? "transform 0.7s ease-in-out"
      : input3
      ? "transform 1s ease-in-out"
      : lastInput
      ? "transform 1.2s ease-in-out"
      : "transform 0.5s ease-in-out"};
  @media (min-width: 992px) {
    transform: ${({ scroll }) =>
      scroll > 2800 ? "translateX(0px)" : "translateX(-500px)"};
  }
`;

export const Svg = styled.svg`
  position: absolute;
  top: ${({ house }) => (house ? "0.2rem" : "0.1rem")};
  left: ${({ user }) => (user ? "0.6rem" : "0.5rem")};
  width: ${({ house, email }) => (house ? "17px" : email ? "19px" : "16px")};
  height: 30px;
  @media (min-width: 992px) {
    top: ${({ house, user, email }) =>
      house ? "0.61rem" : user ? "0.75rem" : email ? "0.6rem" : "0.29rem"};
    left: ${({ user }) => (user ? "0.6rem" : "0.5rem")};
    width: ${({ house, email, pencil }) =>
      house ? "20px" : email ? "23px" : pencil ? "20px" : "18px"};
    height: 30px;
  }
`;
export const Input = styled.input`
  width: 19.7rem;
  height: 36.39px;
  border: 0.699793px solid #999999;
  box-sizing: border-box;
  border-radius: 3.49896px;
  padding-left: 2rem;
  padding-top: ${({ house, user }) =>
    house ? "0.4rem" : user ? "0.5rem" : "0"};
  font-family: "Rubik";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 170%;
  text-decoration: none;
  outline: none;
  color: #676767;
  ::placeholder {
    color: ${({ error }) => (error ? "#CE6C80" : "#676767")};
  }
  @media (min-width: 992px) {
    width: 483px;
    height: 52px;
    font-size: 16px;
    line-height: 170%;
    border: 1px solid #999999;
    box-sizing: border-box;
    border-radius: 5px;
    padding-left: 2.5rem;
    margin-bottom: 0.3rem;
  }
`;
export const TextArea = styled.textarea`
  width: 19.7rem;
  height: 106.37px;
  border: 0.699793px solid #999999;
  box-sizing: border-box;
  border-radius: 3.49896px;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 170%;
  color: #676767;
  padding: 0.5rem 0 0 2rem;
  resize: none;
  outline: none;
  ::placeholder {
    color: ${({ error }) => (error ? "#CE6C80" : "#676767")};
  }
  @media (min-width: 992px) {
    width: 483px;
    height: 152px;
    border: 1px solid #999999;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 16px;
    line-height: 170%;
    padding-left: 2.5rem;
    margin-bottom: 0.3rem;
  }
`;
export const Button = styled.button`
  position: relative;
  transition: width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  width: 19.7rem;
  height: 45px;
  background: #a71b38;
  border-radius: 3.49896;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;
  text-align: center;
  color: #ffffff;
  border: none;
  text-decoration: none;
  align-items: center;
  @media (min-width: 992px) {
    cursor: pointer;
    width: 483px;
    height: 56px;
    border-radius: 5px;
    font-size: 18px;
    line-height: 170%;
    transform: ${({ scroll }) =>
      scroll > 2800 ? "translateY(0)" : "translateY(-24rem)"};
    transition: transform 0.5s ease-in-out, width 0.5s ease-in-out,
      border-radius 0.5s ease-in-out;
  }
`;
export const ErrorFoms = styled.p`
  text-align: start;
  margin: 1rem 0 0 0;
  color: #ce6c80;
  font-size: 10px;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  @media (min-width: 992px) {
    font-size: 0.7rem;
    margin-top: 0.3rem;
  }
`;
export const ContainerCheck = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ContainerSendForm = styled.div`
  position: relative;
  background-color: ${({ error }) =>
    error ? "rgb(232, 109, 88)" : " rgb(217, 237, 248)"};

  border-radius: 5px;
  height: 4vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 20rem;

  padding: 0 0.4rem;
  opacity: ${({ sendMessage, error }) => (sendMessage || error ? "1" : "0")};
  transition: opacity 0.5s ease-in-out;
  @media (min-width: 992px) {
    height: 7vh;

    width: 149vh;
    transition: transform 0.5s ease-in-out;
    padding: 0 1rem;
  }
`;

export const TextMessage = styled.p`
  text-align: start;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 500;
  color: ${({ error }) => (error ? " #fff;" : "#36708f")};
  font-size: 9px;
  @media (min-width: 992px) {
    font-size: 16px;
  }
`;
export const SvgClose = styled.svg`
  width: 12px;
  @media (min-width: 992px) {
    width: 16px;
  }
`;
